import { Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'msh-rating',
  standalone: true,
  imports: [MatIconModule],
  template: `
    <div class="flex items-center gap-0.5">
      @for (star of stars; track star) {
        <div
          type="button"
          class="flex items-center justify-center text-orange-500"
          [class.cursor-pointer]="!readonly()"
          [class.cursor-default]="readonly()"
          (click)="setRating(star)"
        >
          <mat-icon [class]="small() ? 'text-sm !w-auto' : ''" >
            {{ star <= rating() ? 'star' : 'star_border' }}
          </mat-icon>
      </div>
      }
    </div>
  `,
})
export class RatingComponent {
  readonly = input(false);
  small = input(false);
  rating = input(0);

  ratingChange = output<number>();

  readonly stars = [1, 2, 3, 4, 5];

  setRating(rating: number): void {
    if (this.readonly()) {
      return;
    }

    this.ratingChange.emit(rating);
  }
}